import { render, staticRenderFns } from "./ExamListUpdate.vue?vue&type=template&id=1aff6066&"
import script from "./ExamListUpdate.vue?vue&type=script&lang=js&"
export * from "./ExamListUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ExamListUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports